/*
 *  Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('PublicFolderResource', [
        '$resource',
        '$routeParams',
        'PublicFolderInterceptor',
        'relativeUrlRootFilter',
        function (
            $resource,
            $routeParams,
            PublicFolderInterceptor,
            relativeUrlRootFilter
        ) {
            var resource = $resource(relativeUrlRootFilter('/public/folders/:link_uuid/:node_uuid/:action'), {
                link_uuid: _getLinkUUID,
                node_uuid: _getCurrentNodeUUID
            }, {
                get: {
                    interceptor: PublicFolderInterceptor,
                    ignoreApiErrors: true
                },
                query: {
                    method: 'GET',
                    interceptor: PublicFolderInterceptor,
                    isArray: true,
                    params: {
                        action: 'contents'
                    }
                }
            });

            resource.getDownloadUrl = function(node) {
                return node.actions.download;
            };

            return resource;

            function _getLinkUUID() {
                var parsedUrlData = /folders\/([^\/]+)/.exec(window.location.pathname);

                if (parsedUrlData === null || angular.isUndefined(parsedUrlData[1])) {
                    console.error("Can't obtain public folder link ID! You can't use public folder API outside the Public Folder landing page.");
                    return;
                }

                return parsedUrlData[1];
            }

            function _getCurrentNodeUUID() {
                return $routeParams.uuid;
            }
        }
    ]);
